// extracted by mini-css-extract-plugin
export var container = "_fk-0";
export var infoIcon = "_fk-2";
export var titleRowCol = "_fk-1";